import { RolaUzytkownika, Produkt } from "../store/types/organizacje";
import { getData } from "./fetchData";

export const uzytkownicyService = {
  daj,
  zapros,
  zaprosPonownie,
  przegladaj,
  edytuj,
  usun
};

function daj(idOrganizacji: string, idZaproszenia: string) {
  return getData("organizacja/uzytkownicy/daj", {
    IdOrganizacji: idOrganizacji,
    IdZaproszenia: idZaproszenia
  });
}

function zapros(
  idOrganizacji: string,
  email: string,
  rola: RolaUzytkownika,
  produkty: Produkt[],
  wiadomosc: string
) {
  return getData(`organizacja/zaproszenia/wyslij`, {
    IdOrganizacji: idOrganizacji,
    Email: email,
    Rola: rola,
    Produkty: produkty,
    Wiadomosc: wiadomosc
  });
}

function zaprosPonownie(idOrganizacji: string, idZaproszenia: string) {
  return getData(`organizacja/zaproszenia/ponow`, {
    IdOrganizacji: idOrganizacji,
    IdZaproszenia: idZaproszenia
  });
}

function przegladaj(idOrganizacji: string) {
  return getData(`organizacja/uzytkownicy/przegladaj`, {
    IdOrganizacji: idOrganizacji
  });
}

function edytuj(
  idOrganizacji: string,
  idZaproszenia: string,
  rola: RolaUzytkownika,
  produkty: Produkt[]
) {
  return getData(`organizacja/uzytkownicy/zmien`, {
    IdOrganizacji: idOrganizacji,
    IdZaproszenia: idZaproszenia,
    Rola: rola,
    Produkty: produkty
  });
}

function usun(idOrganizacji: string, idZaproszenia: string) {
  return getData(`organizacja/uzytkownicy/usun`, {
    IdOrganizacji: idOrganizacji,
    IdZaproszenia: idZaproszenia
  });
}
